import React from "react";
import { useNavigate } from "react-router-dom";

const HeroPage = () => {
	const navigate = useNavigate();

	return (
		<div className="bg-white flex flex-col items-center pt-20 px-4">
			<h1 className="text-4xl sm:text-5xl font-semibold text-center text-gray-800">
				Get Quick & Hassle Free <span className="text-sky-500">Insurance!</span>
			</h1>

			<p className="text-lg sm:text-xl text-gray-600 text-center mt-4">
				Welcome to One stop Solution for all insurance needs.
			</p>

			<h2 className="text-2xl text-gray-700 font-medium mt-16 mb-10">
				Our Products & Services
			</h2>

			{/* CARDS */}
			<div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
				
				{/* Griha Insurance Card */}
				<div
					className="bg-white shadow-md rounded-xl p-6 flex flex-col items-center hover:shadow-lg transition cursor-pointer"
					onClick={() => navigate("/Griha/Quotation")}
				>
					<img
						src="https://cdn-icons-png.flaticon.com/512/3063/3063815.png"
						alt="Griha Insurance"
						className="w-24 h-24 mb-4"
					/>
					<h3 className="text-lg font-semibold text-gray-800">
						Griha Insurance
					</h3>
					<p className="text-gray-500 text-center mt-2 text-sm">
						Protect your home with comprehensive coverage.
					</p>
				</div>

				{/* Shopkeeper Insurance Card */}
				<div
					className="bg-white shadow-md rounded-xl p-6 flex flex-col items-center hover:shadow-lg transition cursor-pointer"
					onClick={() => navigate("/Shopkeeper/Quotation")}
				>
					<img
						src="https://cdn-icons-png.flaticon.com/512/2331/2331970.png"
						alt="Shopkeeper Insurance"
						className="w-24 h-24 mb-4"
					/>
					<h3 className="text-lg font-semibold text-gray-800">
						Shopkeeper Insurance
					</h3>
					<p className="text-gray-500 text-center mt-2 text-sm">
						Cover your shop from risks & uncertainties.
					</p>
				</div>

				{/* Hospicash Insurance Card */}
				<div
					className="bg-white shadow-md rounded-xl p-6 flex flex-col items-center hover:shadow-lg transition cursor-pointer"
					onClick={() => navigate("/Hospicash/Quotation")}
				>
					<img
						src="https://cdn-icons-png.flaticon.com/512/2966/2966486.png"
						alt="Hospicash Insurance"
						className="w-24 h-24 mb-4"
					/>
					<h3 className="text-lg font-semibold text-gray-800">
						Hospicash Insurance
					</h3>
					<p className="text-gray-500 text-center mt-2 text-sm">
						Receive daily cash benefits during hospitalization.
					</p>
				</div>

			</div>
		</div>
	);
};

export default HeroPage;
